import React, { useState, useEffect, useRef } from 'react';
import styles from './Gallery.module.css';

const Gallery = ({ title, images }: { title: string, images: string[] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);

  // Auto-scroll the thumbnail strip when the active index changes
  useEffect(() => {
    const activeThumb = scrollRef.current?.children[activeIndex] as HTMLElement;
    if (activeThumb) {
      activeThumb.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }, [activeIndex]);

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.galleryStage}>
        
        <div className={styles.overlayTitle}>
          <h1>{title}</h1>
          <p>Artwork {activeIndex + 1} of {images.length}</p>
        </div>

        <div className={styles.mainLandscapeContainer}>
          <img 
            key={activeIndex} 
            src={images[activeIndex]} 
            className={styles.mainFadeImage} 
            alt="Full view"
          />
        </div>

        {/* Added ref to the strip for auto-scrolling */}
        <div className={styles.thumbnailStrip} ref={scrollRef}>
          {images.map((img, index) => (
            <div 
              key={index} 
              className={`${styles.thumbBox} ${activeIndex === index ? styles.active : ''}`}
              onClick={() => setActiveIndex(index)}
            >
              <img src={img} alt={`thumbnail ${index}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;